module.exports = __webpack_public_path__ + "img/result_wine_f.8b3ce7e2.png";